var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 18,
    fill: "url(#paint0_radial_669_15096)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 18,
    fill: "url(#paint1_radial_669_15096)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5012 7.2C15.5681 7.2 15.2 7.21282 14.048 7.26525C12.8982 7.3179 12.1134 7.49992 11.4267 7.767C10.7164 8.04285 10.1138 8.41185 9.51349 9.01237C8.91273 9.61267 8.54373 10.2152 8.26698 10.9253C7.99922 11.6122 7.81697 12.3973 7.76522 13.5466C7.7137 14.6986 7.7002 15.0669 7.7002 18C7.7002 20.9331 7.71325 21.3001 7.76545 22.4521C7.81832 23.6018 8.00035 24.3866 8.2672 25.0733C8.54328 25.7836 8.91228 26.3862 9.51281 26.9865C10.1129 27.5872 10.7155 27.9571 11.4253 28.233C12.1125 28.5001 12.8975 28.6821 14.0471 28.7347C15.1991 28.7872 15.567 28.8 18.4999 28.8C21.4332 28.8 21.8002 28.7872 22.9522 28.7347C24.102 28.6821 24.8877 28.5001 25.5748 28.233C26.2849 27.9571 26.8866 27.5872 27.4867 26.9865C28.0874 26.3862 28.4564 25.7836 28.7332 25.0735C28.9987 24.3866 29.1809 23.6016 29.2349 22.4523C29.2867 21.3003 29.3002 20.9331 29.3002 18C29.3002 15.0669 29.2867 14.6988 29.2349 13.5468C29.1809 12.397 28.9987 11.6122 28.7332 10.9255C28.4564 10.2152 28.0874 9.61267 27.4867 9.01237C26.8859 8.41162 26.2852 8.04262 25.5742 7.767C24.8856 7.49992 24.1004 7.3179 22.9506 7.26525C21.7986 7.21282 21.4319 7.2 18.4978 7.2H18.5012ZM17.5323 9.14625C17.8199 9.1458 18.1408 9.14625 18.5012 9.14625C21.3848 9.14625 21.7266 9.1566 22.8654 9.20835C23.9184 9.2565 24.4899 9.43245 24.8706 9.58027C25.3746 9.77602 25.7339 10.01 26.1117 10.388C26.4897 10.766 26.7237 11.126 26.9199 11.63C27.0677 12.0103 27.2439 12.5818 27.2918 13.6348C27.3436 14.7733 27.3548 15.1153 27.3548 17.9975C27.3548 20.8798 27.3436 21.2218 27.2918 22.3603C27.2437 23.4133 27.0677 23.9848 26.9199 24.365C26.7241 24.869 26.4897 25.2279 26.1117 25.6057C25.7337 25.9837 25.3748 26.2177 24.8706 26.4134C24.4903 26.5619 23.9184 26.7374 22.8654 26.7856C21.7268 26.8373 21.3848 26.8486 18.5012 26.8486C15.6174 26.8486 15.2756 26.8373 14.1371 26.7856C13.0841 26.737 12.5125 26.561 12.1316 26.4132C11.6276 26.2174 11.2676 25.9834 10.8896 25.6054C10.5116 25.2274 10.2776 24.8683 10.0814 24.3641C9.93357 23.9839 9.75739 23.4124 9.70947 22.3594C9.65772 21.2209 9.64737 20.8789 9.64737 17.9948C9.64737 15.1108 9.65772 14.7706 9.70947 13.6321C9.75762 12.5791 9.93357 12.0076 10.0814 11.6269C10.2771 11.1229 10.5116 10.7629 10.8896 10.3849C11.2676 10.0069 11.6276 9.77287 12.1316 9.57667C12.5123 9.42817 13.0841 9.25267 14.1371 9.2043C15.1334 9.1593 15.5195 9.1458 17.5323 9.14355V9.14625ZM24.2662 10.9395C23.5507 10.9395 22.9702 11.5193 22.9702 12.235C22.9702 12.9505 23.5507 13.531 24.2662 13.531C24.9817 13.531 25.5622 12.9505 25.5622 12.235C25.5622 11.5195 24.9817 10.939 24.2662 10.939V10.9395ZM18.5012 12.4537C15.4383 12.4537 12.9549 14.9371 12.9549 18C12.9549 21.0629 15.4383 23.5451 18.5012 23.5451C21.5642 23.5451 24.0466 21.0629 24.0466 18C24.0466 14.9371 21.5639 12.4537 18.501 12.4537H18.5012ZM18.5012 14.4C20.4893 14.4 22.1012 16.0117 22.1012 18C22.1012 19.9881 20.4893 21.6 18.5012 21.6C16.5129 21.6 14.9012 19.9881 14.9012 18C14.9012 16.0117 16.5129 14.4 18.5012 14.4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_669_15096",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0625 38.7728) rotate(-90) scale(35.6787 33.184)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_669_15096",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.53019 2.59338) rotate(78.6806) scale(15.9485 65.7404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3e0e33996e33c72ca271071a9e765a79.svg";
export { ForwardRef as ReactComponent };